import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import DatePickerSample from "../../DatePicker";
import styles from "../BookModule/BookModule.module.css";
import { Search } from "@mui/icons-material";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import Loader from "../../Loader";
import toast from "react-hot-toast";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import ModelExamStatus from "./ModelExamStatus";

function MockInterview(props) {
  const moment = require("moment-timezone");
  const filterRef_batch_name = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_section = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_interview_mode = useRef(null);
  const filterRef_status = useRef(null);
  const txtBSearch = useRef(null);
  const filterStartRef = useRef(null);
  const filterCreatedOnRef = useRef(null);

  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterRef_location = useRef(null);
  const txtBSearch_course = useRef(null);
  const locationS = useLocation();
  const {
    filStatus,
    filCateCode,
    fillClassMode,
    fillClassType,
    fillLoca,
    fillAon,
    fillCOn,
    fillSearch,
    ftype,
  } = locationS.state ? locationS.state : {};

  let page = R_PER_PAGE;
  const currentDate = moment();
  const startOfDay = moment(currentDate).startOf("day");
  const tenAM = startOfDay.clone().hour(10);
  // use state
  const [csvData, setCsvData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState();
  const [csvListData, setCsvListData] = useState([]);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [isOpen, setIsOpen] = useState({
    status: false,
    time: false,
    startDate: false,

    category: false,
    section: false,
    created_on: false,
    interview_mode: false,
    medium: false,
    interview_type: false,
    location: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [appData_on, setAppData_on] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const [category_on, setCategory_on] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [interview_mode, setInterview_mode] = useState([]);
  const [interview_type, setInterview_type] = useState([]);

  const [branch, setBranch] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [location, setLocation] = useState([]);
  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appOn_on, setAppOn_on] = useState([]);
  const [mediums, setMedium] = useState([]);
  let filterStatus = [];
  let filterCategory = [];
  let filterLocation = [];
  let filterInterviewMode = [];
  let filterInterviewType = [];

  let filterMedium = [];
  let filterApplyed = [];
  let filterApplyed_on = [];
  let filterSearch = [];
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     const isCheckbox = event.target.closest('input[type="checkbox"]');
  //     const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
  //     const isChipData = event.target.closest(".paperil_global");
  //     if (isCheckbox || isApplyFilterButton || isChipData) return;
  //     if (
  //       filterRef_category.current &&
  //       !filterRef_category.current.contains(event.target)
  //     ) {
  //       {
  //         const hasCategory = updateChipData.some(
  //           (chipItem) => chipItem.type === "category"
  //         );
  //         if (hasCategory) {
  //           const updatedCategory = updateChipData.filter(
  //             (chipItem) => chipItem.type === "category"
  //           );
  //           setCategory_on(updatedCategory);
  //         } else {
  //           setCategory_on([]);
  //         }
  //         setIsOpen((prev) => ({ ...prev, category: false }));
  //       }
  //     }
  //     if (
  //       filterRef_location.current &&
  //       !filterRef_location.current.contains(event.target)
  //     ) {
  //       {
  //         const hasLocation = updateChipData.some(
  //           (chipItem) => chipItem.type === "location"
  //         );
  //         if (hasLocation) {
  //           const updatedLoaction = updateChipData.filter(
  //             (chipItem) => chipItem.type === "location"
  //           );
  //           setLocation(updatedLoaction);
  //         } else {
  //           setLocation([]);
  //         }
  //         setIsOpen((prev) => ({ ...prev, location: false }));
  //       }
  //     }
  //     if (
  //       filterRef_interview_mode.current &&
  //       !filterRef_interview_mode.current.contains(event.target)
  //     ) {
  //       {
  //         const hasInterviewMode = updateChipData.some(
  //           (chipItem) => chipItem.type === "interview_mode"
  //         );
  //         if (hasInterviewMode) {
  //           const updateInterviewMode = updateChipData.filter(
  //             (chipItem) => chipItem.type === "interview_mode"
  //           );
  //           setInterview_mode(updateInterviewMode);
  //         } else {
  //           setInterview_mode([]);
  //         }
  //         setIsOpen((prev) => ({ ...prev, interview_mode: false }));
  //       }
  //     }
  //     if (
  //       filterRef_section.current &&
  //       !filterRef_section.current.contains(event.target)
  //     ) {
  //       {
  //         const hasSection = updateChipData.some(
  //           (chipItem) => chipItem.type === "section"
  //         );
  //         if (hasSection) {
  //           const updateSection = updateChipData.filter(
  //             (chipItem) => chipItem.type === "section"
  //           );
  //           setSection_on(updateSection);
  //         } else {
  //           setSection_on([]);
  //         }
  //         setIsOpen((prev) => ({ ...prev, section: false }));
  //       }
  //     }
  //     if (
  //       filterStartRef.current &&
  //       !filterStartRef.current.contains(event.target)
  //     ) {
  //       const mismatchedDay = updateChipData.find(
  //         (chipItem) => chipItem.Days && chipItem.Days === appData.Days
  //       );
  //       if (mismatchedDay) {
  //         setAppData({
  //           FDate: "",
  //           TDate: "",
  //           Days: mismatchedDay.Days,
  //         });
  //         setAppOn([
  //           {
  //             name: mismatchedDay.name || "",
  //             FDate: "",
  //             TDate: "",
  //             Days: mismatchedDay.Days,
  //           },
  //         ]);
  //       } else {
  //         const mismatchedDate = updateChipData.find(
  //           (chipItem) =>
  //             chipItem.fdate === appData.FDate &&
  //             chipItem.edate === appData.TDate
  //         );
  //         if (mismatchedDate) {
  //           setAppData((prev) => ({
  //             ...prev,
  //             FDate: mismatchedDate.fdate,
  //             TDate: mismatchedDate.edate,
  //             Days: "",
  //           }));
  //           setAppOn([
  //             {
  //               name:
  //                 mismatchedDate.name ||
  //                 `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
  //               FDate: mismatchedDate.fdate,
  //               TDate: mismatchedDate.edate,
  //               Days: "",
  //             },
  //           ]);
  //         } else {
  //           setAppData({
  //             FDate: "",
  //             TDate: "",
  //             Days: "",
  //           });
  //           setAppOn([]);
  //         }
  //       }
  //       setIsOpen((prev) => ({ ...prev, startDate: false }));
  //     }
  //     if (
  //       filterCreatedOnRef.current &&
  //       !filterCreatedOnRef.current.contains(event.target)
  //     ) {
  //       const mismatchedDay = updateChipData.find(
  //         (chipItem) => chipItem.Days && chipItem.Days === appData_on.Days
  //       );
  //       if (mismatchedDay) {
  //         setAppData_on({
  //           FDate: "",
  //           TDate: "",
  //           Days: mismatchedDay.Days,
  //         });
  //         setAppOn_on([
  //           {
  //             name: mismatchedDay.name || "",
  //             FDate: "",
  //             TDate: "",
  //             Days: mismatchedDay.Days,
  //           },
  //         ]);
  //       } else {
  //         const mismatchedDate = updateChipData.find(
  //           (chipItem) =>
  //             chipItem.fdate === appData_on.FDate &&
  //             chipItem.edate === appData_on.TDate
  //         );
  //         if (mismatchedDate) {
  //           setAppData_on((prev) => ({
  //             ...prev,
  //             FDate: mismatchedDate.fdate,
  //             TDate: mismatchedDate.edate,
  //             Days: "",
  //           }));
  //           setAppOn_on([
  //             {
  //               name: mismatchedDate.name || `${mismatchedDate.fdate} - ${mismatchedDate.edate}`,
  //               FDate: mismatchedDate.fdate,
  //               TDate: mismatchedDate.edate,
  //               Days: "",
  //             },
  //           ]);
  //         } else {
  //           setAppData_on({
  //             FDate: "",
  //             TDate: "",
  //             Days: "",
  //           });
  //           setAppOn_on([]);
  //         }
  //       }
  //       setIsOpen((prev) => ({ ...prev, created_on: false }));
  //     }
  //     if (
  //       filterRef_status.current &&
  //       !filterRef_status.current.contains(event.target)
  //     ) {
  //       {
  //         const hasStatus = updateChipData.some(
  //           (chipItem) => chipItem.type === "status"
  //         );
  //         if (hasStatus) {
  //           const updateStatus = updateChipData.filter(
  //             (chipItem) => chipItem.type === "status"
  //           );
  //           setStatus(updateStatus);
  //         } else {
  //           setStatus([]);
  //         }
  //         setIsOpen((prev) => ({ ...prev, status: false }));
  //       }
  //     }

  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [
  //   updateChipData,
  //   category_on,
  //   course_on,
  //   initialfields,
  //   appData,
  //   appData_on
  // ]);

  useEffect(() => {
    loadChipdata();
  }, []);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    filterStatus = status;
  }, [status]);
  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);
  useEffect(() => {
    filterLocation = location;
  }, [location]);

  useEffect(() => {
    filterInterviewMode = interview_mode;
  }, [interview_mode]);
  useEffect(() => {
    filterInterviewType = interview_type;
  }, [interview_type]);
  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);
  useEffect(() => {
    filterApplyed_on = appOn_on;
  }, [appOn_on]);

  // useEffect(() => {
  //   filterMedium = mediums;
  // }, [mediums]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    loadChipdata();
  }, []);
  useEffect(() => {
    if (props.activeTab === 6) {
      if (filStatus && filStatus.length > 0 && ftype === 5) {
        setStatus(filStatus);
        filterStatus = filStatus;
      } else {
        setStatus(status);
        filterStatus = status;
      }
      if (filCateCode && filCateCode.length > 0 && ftype === 5) {
        setCategory_on(filCateCode);
        filterCategory = filCateCode;
      } else {
        setCategory_on(category_on);
        filterCategory = category_on;
      }
      if (fillClassMode && fillClassMode.length > 0 && ftype === 5) {
        setInterview_mode(fillClassMode);
        filterInterviewMode = fillClassMode;
      } else {
        setInterview_mode(interview_mode);
        filterInterviewMode = interview_mode;
      }
      if (fillClassType && fillClassType.length > 0 && ftype === 5) {
        setInterview_type(fillClassType);
        filterInterviewType = fillClassType;
      } else {
        setInterview_type(interview_type);
        filterInterviewType = interview_type;
      }

      if (fillLoca && fillLoca.length > 0 && ftype === 5) {
        setLocation(fillLoca);
        filterLocation = fillLoca;
      } else {
        setLocation(location);
        filterLocation = location;
      }

      if (fillSearch && fillSearch.length > 0 && ftype === 5) {
        filterSearch = [{ name: "" + fillSearch, type: "search" }];
        setSearchTerm(fillSearch);
      } else {
        if (searchTerm) {
          setSearchTerm(searchTerm);
          filterSearch = [{ name: "" + searchTerm, type: "search" }];
        }
      }
      if (fillAon && fillAon.length > 0 && ftype === 5) {
        const filterDates = fillAon[0];
        setAppData({
          FDate: filterDates.fdate,
          TDate: filterDates.edate,
          Days: filterDates.Days,
          name: "",
        });
        setAppOn(fillAon);
        filterApplyed = fillAon;
      } else {
        setAppOn(appOn);
        filterApplyed = appOn;
      }

      if (fillCOn && fillCOn.length > 0 && ftype === 5) {
        const filterDates = fillCOn[0];

        setAppData_on({
          FDate: filterDates.fdate,
          TDate: filterDates.edate,
          Days: filterDates.Days,
          name: "",
        });
        setAppOn_on(fillCOn);
        filterApplyed_on = fillCOn;
      } else {
        setAppOn_on(appOn_on);
        filterApplyed_on = appOn_on;
      }
      setIsFiltersInitialized(true);
      loadChipdata();
    }
  }, [
    props.activeTab,
    filStatus,
    filCateCode,
    fillClassMode,
    fillLoca,
    fillSearch,
    fillAon,
    fillCOn,
  ]);
  useEffect(() => {
    if (props.activeTab === 6) {
      if (isFiltersInitialized && filStatus && filStatus.length > 0) {
        loadListdata();
      } else if (
        isFiltersInitialized &&
        filCateCode &&
        filCateCode.length > 0
      ) {
        loadListdata();
      } else if (
        isFiltersInitialized &&
        fillClassMode &&
        fillClassMode.length > 0
      ) {
        loadListdata();
      } else if (isFiltersInitialized && fillLoca && fillLoca.length > 0) {
        loadListdata();
      } else if (isFiltersInitialized && fillAon && fillAon.length > 0) {
        loadListdata();
      } else if (isFiltersInitialized && fillCOn && fillCOn.length > 0) {
        loadListdata();
      }
      if (isFiltersInitialized && fillSearch && fillSearch.length > 0) {
        loadListdata();
      }
      loadListdata();
    }
  }, [
    props.activeTab,
    filStatus,
    filCateCode,
    fillClassMode,
    fillLoca,
    fillAon,
    fillCOn,
    fillSearch,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        let branches = res.data.data.map((item) => item);
        setBranch(branches);
      })
      .catch((error) => {
        console.error("Error fetching branch list:", error);
      });
  }, [props.activeTab]);
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  function updateStateData() {
    filterStatus = status;
    filterCategory = category_on;
    filterApplyed = appOn;
    filterApplyed_on = appOn_on;
    filterLocation = location;
    filterInterviewMode = interview_mode;
    filterInterviewType = interview_type;

    // filterMedium = mediums;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey, type) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    let sortedList = updateListData.sort((a, b) => {
      // Check if the sortKey is a date
      if (type === "date") {
        // Convert date strings to timestamps for comparison
        let dateA = new Date(a[sortKey]).getTime();
        let dateB = new Date(b[sortKey]).getTime();

        if (dateA < dateB) {
          return order === "asc" ? -1 : 1;
        }
        if (dateA > dateB) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      } else if (sortKey === "dateTime") {
        let dateA = moment(a[sortKey], "DD/MM/YYYY HH:mm:ss");
        let dateB = moment(b[sortKey], "DD/MM/YYYY HH:mm:ss");

        if (dateA.isBefore(dateB)) {
          return order === "asc" ? -1 : 1;
        }
        if (dateA.isAfter(dateB)) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      } else {
        // Handle non-date fields
        if (a[sortKey] < b[sortKey]) {
          return order === "asc" ? -1 : 1;
        }
        if (a[sortKey] > b[sortKey]) {
          return order === "asc" ? 1 : -1;
        }
        return 0;
      }
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (name === "Upcoming" || name === "Ongoing" || name === "Completed") {
      if (checked) {
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "interview_mode") {
      if (checked) {
        setInterview_mode([{ id: value, name: name, type: "interview_mode" }]);
      } else {
        setInterview_mode(interview_mode.filter((item) => item.id !== value));
      }
    } else if (typename === "interview_type") {
      if (checked) {
        setInterview_type([{ id: value, name: name, type: "interview_type" }]);
      } else {
        setInterview_type(interview_type.filter((item) => item.id !== value));
      }
    } else if (typename === "location") {
      if (checked) {
        setLocation([...location, { id: value, name: name, type: "location" }]);
      } else {
        setLocation(location.filter((item) => item.id !== value));
      }
    }
    //  else if (name === "English" || name === "Tamil") {
    //   if (checked) {
    //     setMedium([...mediums, { id: value, name: name, type: "medium" }]);
    //   } else {
    //     setMedium(mediums.filter((item) => item.id !== value));
    //   }
    // }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setCategory_on([]);
    setInterview_mode([]);
    setInterview_type([]);

    setAppOn_on([]);
    setLocation([]);
    setUpdateChipData([]);
    loadListdata();
    setAppOn([]);
    setMedium([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    setAppData_on({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "category") {
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "status") {
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "interview_mode") {
      setIsOpen({
        ...isOpen,
        interview_mode: false,
      });
    } else if (name === "appliedOn") {
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "appliedOns") {
      setIsOpen({
        ...isOpen,
        created_on: false,
      });
    } else if (name === "location") {
      setIsOpen({
        ...isOpen,
        location: false,
      });
    } else if (name === "time") {
      setIsOpen({
        ...isOpen,
        time: false,
      });
    } else if (name === "interview_type") {
      setIsOpen({
        ...isOpen,
        interview_type: false,
      });
    } else if (name === "medium") {
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    }
    loadChipdata();
  };
  function StatusDate(course, currentDate) {
    let StausOrder = 0;
    const startDate = moment(course.started_dt);
    const endDate = moment(course.end_dt);

    if (
      currentDate.isBetween(
        startDate,
        endDate,
        "day",
        "[]" // Include the end date
      ) &&
      currentDate.isAfter(tenAM)
    ) {
      StausOrder = 1;
    } else if (
      currentDate.isBefore(startDate, "day") ||
      (currentDate.isSame(startDate, "day") && currentDate.isBefore(tenAM))
    ) {
      StausOrder = 0;
    } else {
      StausOrder = 2;
    }

    return StausOrder;
  }
  function loadListdata() {
    let tempstatus = [];
    let tempCateon = [];
    let tempLocanum = [];
    let templocation = [];
    let tempInterviewMode = [];
    let tempInterviewType = [];
    let tempMedium = [];
    let tempstatusnum = [];
    status.map((obj) => {
      tempstatus.push(obj.id);
    });

    interview_mode.map((obj) => {
      tempInterviewMode.push(obj.name);
    });
    interview_type.map((obj) => {
      tempInterviewType.push(obj.id);
    });

    mediums.map((obj) => {
      tempMedium.push(obj.name);
    });

    location.map((obj) => {
      templocation.push(obj.id);
    });

    category_on.map((obj) => {
      tempCateon.push(obj.name);
    });
    tempLocanum = templocation.map(Number);
    tempstatusnum = tempstatus.map(Number);
    let statusFilter = {
      category: tempCateon.length > 0 ? tempCateon : "",
      status: status.length > 0 ? tempstatusnum : "",
      batch_type: "",
      medium: mediums.length > 0 ? tempMedium : "",
      class_mode: interview_mode.length > 0 ? tempInterviewMode : "",
      paper_type: interview_type.length > 0 ? tempInterviewType : "",

      start_date: appOn.length > 0 ? appOn[0].fdate + " 00:00:00" : "",
      end_date: appOn.length > 0 ? appOn[0].edate + " 23:59:00" : "",
      c_start_date: appOn_on.length > 0 ? appOn_on[0].fdate : "",
      c_end_date: appOn_on.length > 0 ? appOn_on[0].edate : "",
      start_time: "",
      end_time: "",
      search: searchTerm.length > 0 ? searchTerm : "",
      type: "5",
      location: location.length > 0 ? tempLocanum : "",
      last_apply_st: "",
      last_apply_ed: "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/batch/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          setCurrentPage(1);
          const fiatas = res.data.data;
          const fiata = fiatas.sort((a, b) => {
            const dateA = moment(a.created_on, "DD/MM/YYYY hh:mm:ss A");
            const dateB = moment(b.created_on, "DD/MM/YYYY hh:mm:ss A");
            return dateB - dateA;
          });
          const bb = fiata.map((obj, index) => ({
            ...obj,
            statusOrder: StatusDate(obj, currentDate),
          }));
          const fiatssa = bb.sort((a, b) => {
            return a.statusOrder - b.statusOrder;
          });
          const serialNumberAddedData = fiatssa.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          // setUpdateListData(fiata);
          setUpdateListData(serialNumberAddedData);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            name: item.name,
            subcategory: item.subcategory,
            class_mode: item.class_mode,
            // "class_mode":el.class_mode,
            // "medium": el.medium,
            // "batch_type": el.batch_type,
            exam_fees: item.exam_fees,
            created_on: item.created_on,
            status: item.status,
          }));
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterInterviewMode.map((obj) => {
      tempArr.push(obj);
    });
    filterInterviewType.map((obj) => {
      tempArr.push(obj);
    });
    filterLocation.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed_on.map((obj) => {
      tempArr.push(obj);
    });
    // filterMedium.map((obj) => {
    //   tempArr.push(obj);
    // });

    setUpdateChipData(tempArr);
  }

  useEffect(() => {
    if (props.tabChanged) {
      handleAllClear();
      props.setTabChanged(false);
    }
  }, [props.tabChanged]);

  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        startDate: false,
      });
    } else if (name === "created_on") {
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_on([]);
      filterApplyed_on = [];
      setIsOpen({
        ...isOpen,
        created_on: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "category") {
      // Clear the status array
      setCategory_on([]);
      filterCategory = [];
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "interview_mode") {
      setInterview_mode([]);
      filterInterviewMode = [];

      setIsOpen({
        ...isOpen,
        interview_mode: false,
      });
    } else if (name === "interview_type") {
      setInterview_type([]);
      filterInterviewType = [];

      setIsOpen({
        ...isOpen,
        interview_type: false,
      });
    }
    // else if (name === "medium") {
    //   setMedium([]);
    //   filterMedium = [];

    //   setIsOpen({
    //     ...isOpen,
    //     medium: false,
    //   });
    // }
    else if (name === "location") {
      // Clear the status array
      setLocation([]);
      filterLocation = [];
      setIsOpen({
        ...isOpen,
        location: false,
      });
    }
    loadChipdata();
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "category") {
      setCategory_on(status.filter((item) => item.id !== chipToDelete.id));
      filterCategory = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "location") {
      setLocation(location.filter((item) => item.id !== chipToDelete.id));
      filterLocation = location.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "dayRange_on") {
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_on([]);
      filterApplyed_on = [];
    } else if (chipToDelete.type === "interview_mode") {
      setInterview_mode(
        interview_mode.filter((item) => item.id !== chipToDelete.id)
      );
      filterInterviewMode = interview_mode.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "interview_type") {
      setInterview_type(
        interview_type.filter((item) => item.id !== chipToDelete.id)
      );
      filterInterviewType = interview_type.filter(
        (item) => item.id !== chipToDelete.id
      );
    }

    else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setAppData_on({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn_on([]);
      filterApplyed_on = [];
    }
    loadChipdata();
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppData_on((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn_on([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);

  useEffect(() => {
    // Clear state only once AFTER all tabs are rendered
    if (location.state) {
      const timer = setTimeout(() => {
        navigate(location.pathname, { replace: true, state: null });
      }, 100); // give child tabs time to read it
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);
  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        time: false,
        startDate: false,
        category: false,
        // course:false,
        medium: false,
        interview_mode: false,
        location: false,
        status: !prevState.status,
      }));
    } else if (boxName === "location") {
      setIsOpen((prevState) => ({
        time: false,
        startDate: false,
        category: false,
        created_on: false,
        medium: false,
        interview_mode: false,
        status: false,
        location: !prevState.location,
      }));
    } else if (boxName === "time") {
      setIsOpen((prevState) => ({
        startDate: false,

        category: false,
        created_on: false,
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: !prevState.time,
      }));
    } else if (boxName === "created_on") {
      setIsOpen((prevState) => ({
        startDate: false,

        category: false,
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: !prevState.created_on,
      }));
    } else if (boxName === "startDate") {
      setIsOpen((prevState) => ({
        category: false,
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: !prevState.startDate,
      }));
    } else if (boxName === "created_on") {
      setIsOpen((prevState) => ({
        category: false,
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,
        startDate: false,
        created_on: !prevState.created_on,
      }));
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,

        category: !prevState.category,
      }));
    } else if (boxName === "section") {
      setIsOpen((prevState) => ({
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,

        category: false,
        section: !prevState.section,
      }));
    } else if (boxName === "interview_mode") {
      setIsOpen((prevState) => ({
        medium: false,
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,

        category: false,
        section: false,
        interview_mode: !prevState.interview_mode,
      }));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        interview_mode: false,
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,

        category: false,
        medium: !prevState.medium,
      }));
    } else if (boxName === "interview_type") {
      setIsOpen((prevState) => ({
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,
        medium: false,
        category: false,
        interview_mode: false,
        interview_type: !prevState.interview_type,
      }));
    } else if (boxName === "status") {
      setIsOpen((prevState) => ({
        status: false,
        location: false,
        time: false,
        created_on: false,
        startDate: false,

        category: false,
        medium: false,
      }));
    }
  };

  const generatePDF = () => {
    const headers = [
      "Batch Name",
      "Course",
      "Interview Mode",
      "Batch Amount",
      "Created_On",
      "Status",
    ];

    const rows = csvData.map((item, index) => [
      item.name ?? "-",
      item.subcategory ?? "-",
      item.class_mode ?? "-",
      item.exam_fees ?? "-",
      item.created_on ?? "-",
      item.status ?? "-",
    ]);

    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Mock Interview List",
          headers,
          rows,
          filename: "MockInterviewList.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData?.slice(start, end);

  const handleReadView = (id, type) => {
    navigate(`/DetailViewBatch/${id}/${type}`, {
      state: {
        FCAF: category_on,
        FCM: interview_mode,
        FIT: interview_type,
        FLO: location,
        FSTD: appOn,
        FCON: appOn_on,
        FSF: status,
        FSEAR: searchTerm,
        ftype: 5,
      },
    });
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Batch Name", key: "name" },
    { label: "Course", key: "subcategory" },
    { label: "Interview Mode", key: "class_mode" },
    { label: "Batch Amount", key: "exam_fees" },
    { label: "Created_On", key: "created_on" },
    { label: "Status", key: "status" },
  ];
  // className="row tab-content mt-4"
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={
        props.activeTab === 6 ? " tab-content mt-4" : " tab-content mt-4 hide "
      }
      id="ex2-content"
    >
      <div className="row">
        <div className="col-lg-3 col-md-12">
          <div class="input-group">
            <input
              ref={txtBSearch}
              type="text"
              class="Inputs"
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Name and course"
              // onChange={handleSearch}
              onKeyDown={handleSearch}
            />
            <span class="input-group-text" id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>search</span>
            </span>
          </div>
        </div>
        {/* <div className="col-lg-3 col-md-2"></div> */}
        <div className="col-md-9 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={csvData?.length > 0 ? csvData : ""}
                iconName=" file_download "
                headers={csvHeaders}
                filename={"MockInterview.csv"}
                csvName="Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
            <li class="ListBtnItems">
              <Link
                to="/CreateCourseBatch/5"
                className="primaryButton "
                variant="primary"
              >
                Create New Mock Interview Batch
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {updateChipData.length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                let key = "" + data.name;
                return (
                  <ListItem key={data}>
                    <Chip
                      icon={icon}
                      label={key}
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}

              <ListItem>
                {/* <Chip
                      label="clear all filter"
                      onClick={handleAllClear}
                    /> */}
                <a className="allclear" href="#" onClick={handleAllClear}>
                  clear all filter
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                <th id="th">
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id={"th"} ref={filterRef_batch_name}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    Batch Name
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "location")}
                  >
                    import_export
                  </span>
                </th>
                <th
                  id="th"
                  className={styles.tableThPadding}
                  ref={filterRef_category}
                >
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "category")}
                  >
                    Category
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "category")}
                  >
                    import_export{" "}
                  </span>
                  <span
                    className={`textHead_th align-middle material-icons ${category_on.length > 0 || isOpen.category
                        ? styles.active_icons_book
                        : ""
                      } `}
                    onClick={(e) => handleFilter(e, "category")}
                  >
                    filter_list
                  </span>

                  {isOpen.category && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {categoryId.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.name}
                                  value={el.id}
                                  id={el.name}
                                  checked={category_on.some((element) => {
                                    if (element.name == el.name) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, el.name, "category")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.name}
                                >
                                  {el.name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("category")}
                              className="secondaryButton "
                            >
                              Clear
                            </Link>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  category_on.length === 0 ? true : false
                                }
                                onClick={() => handleApplyFilter("category")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>

                <th
                  id="th"
                  className={styles.tableThPadding}
                  ref={filterRef_course}
                >
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "group_course_name")}
                  >
                    Course
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "group_course_name")}
                  >
                    import_export{" "}
                  </span>
                  {/* <span
                    className={`textHead_th align-middle material-icons ${course_on.length > 0 || isOpen.course
                      ? styles.active_icons_book
                      : ""
                      } ${isOpen.course ? styles.active_icons_book : ""}`} // Change here
                    onClick={(e) => handleFilter(e, "course")}
                  >
                    filter_list
                  </span>
                  {isOpen.course && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li
                              className={`filterListData ${styles.searchInputSec}`}
                            >
                              <input
                                className={`${styles.searchInput} w-100`}
                                type="text"
                                placeholder="Search by course"
                                name="search_book_title"
                                onKeyDown={(e) =>
                                  handleFilterCourseSearch(e, "course")
                                }
                                ref={txtBSearch_course}
                              />
                              <Search
                                onClick={(e) =>
                                  handleFilterSearchFocus("course")
                                }
                                className={`${styles.ListsearchIcon}`}
                              />
                            </li>

                            {courseIds.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.course_name}
                                  value={el.course_id}
                                  id={el.course_name}
                                  checked={course_on.some((element) => {
                                    if (element.id == el.course_id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      el.course_name,
                                      "course"
                                    )
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.course_name}
                                >
                                  {el.course_name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("course")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={course_on.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("course")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )} */}
                </th>
                <th id={"th"} ref={filterRef_interview_mode}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "interview_mode")}
                  >
                    Interview Mode
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "class_mode")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${interview_mode.length > 0 || isOpen.interview_mode
                        ? styles.active_icons_book
                        : ""
                      }`}
                    onClick={(e) => handleFilter(e, "interview_mode")}
                  >
                    filter_list
                  </span>
                  {isOpen.interview_mode && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Online"}
                                value={"1"}
                                checked={interview_mode.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Online"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "interview_mode",
                                    "interview_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Online"}
                              >
                                Online
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Classroom"}
                                value={"0"}
                                checked={interview_mode.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Classroom"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "interview_mode",
                                    "interview_mode"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Classroom"}
                              >
                                Classroom
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("interview_mode")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  interview_mode.length === 0 ? true : false
                                }
                                onClick={() =>
                                  handleApplyFilter("interview_mode")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_interview_mode}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "paper_type")}
                  >
                    Interview Type
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "paper_type")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${interview_type.length > 0 || isOpen.interview_type
                        ? styles.active_icons_book
                        : ""
                      }`}
                    onClick={(e) => handleFilter(e, "interview_type")}
                  >
                    filter_list
                  </span>
                  {isOpen.interview_type && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Interview"}
                                value={"0"}
                                checked={interview_type.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Interview"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "interview_type",
                                    "interview_type"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"Interview"}
                              >
                                Interview
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"ClassCum"}
                                value={"1"}
                                checked={interview_type.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"ClassCum"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "interview_type",
                                    "interview_type"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG "
                                htmlFor={"ClassCum"}
                              >
                                Class Cum Interview
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("interview_type")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={
                                  interview_type.length === 0 ? true : false
                                }
                                onClick={() =>
                                  handleApplyFilter("interview_type")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id={"th"} ref={filterRef_location}>
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "delivery_mode")}
                  >
                    Location
                  </span>
                  <span
                    className={` material-icons align-middle`}
                    onClick={(e) => handleSort(e, "location")}
                  >
                    import_export
                  </span>
                  <span
                    class={` textHead_th align-middle material-icons ${location.length > 0 || isOpen.location
                        ? styles.active_icons_book
                        : ""
                      }`}
                    onClick={(e) => handleFilter(e, "location")}
                  >
                    filter_list
                  </span>
                  {isOpen.location && (
                    <>
                      <div className="filterBoxs_testlist mt-3">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            {branch.map((el) => (
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name={el.name}
                                  value={el.id}
                                  id={el.name}
                                  checked={location.some((element) => {
                                    if (element.id == el.id) {
                                      return true;
                                    }
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, el.name, "location")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText_withoutBG "
                                  htmlFor={el.name}
                                >
                                  {el.name}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("location")}
                                className="secondaryButton "
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                disabled={location.length === 0 ? true : false}
                                onClick={() => handleApplyFilter("location")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </th>
                <th id="th">
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "total_amount")}
                  >
                    {" "}
                    Number of Interview
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "total_amount")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "exam_fees")}
                  >
                    Batch Amount
                  </span>
                  <span
                    className={`textHead_th material-icons align-middle`}
                    onClick={(e) => handleSort(e, "exam_fees")}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" ref={filterStartRef}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "apply_last_date")}
                  >
                    {" "}
                    Last Date to Apply
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "apply_last_date")}
                  >
                    import_export
                  </span>{" "}
                </th>
                <th id="th" ref={filterStartRef}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "started_dt")}
                  >
                    {" "}
                    Start Date
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "started_dt")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "startDate")}
                    class={` align-middle material-icons ${(appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                        isOpen.startDate
                        ? styles.active_icons_book
                        : ""
                      }`}
                  >
                    filter_list
                  </span>
                  {isOpen.startDate && (
                    <div className="filterBoxs_testlist container  p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.FDate}
                              txtAdMDob={fDatePickerRef}
                            // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appData.FDate}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOn")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOn")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th" ref={filterCreatedOnRef}>
                  <span
                    className="textHead_th"
                    onClick={(e) => handleSort(e, "created_on")}
                  >
                    {" "}
                    Created On
                  </span>
                  <span
                    className={`material-icons textHead_th align-middle`}
                    onClick={(e) => handleSort(e, "created_on")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "created_on")}
                    class={` align-middle material-icons ${(appData_on &&
                        Object.entries(appData_on).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                        isOpen.created_on
                        ? styles.active_icons_book
                        : ""
                      }`}
                  >
                    filter_list
                  </span>
                  {isOpen.created_on && (
                    <div className="filterBoxs_testlist container  p-1">
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appData_on.FDate}
                              txtAdMDob={fDatePickerRef}
                            // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate_app}
                              fieldInput={appData_on.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appData_on.FDate}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOns")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOns")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id={"th"} ref={filterRef_status}>
                  <span className="text_th">Status</span>

                  <span
                    class={` textHead_th align-middle material-icons ${status.length > 0 || isOpen.status
                        ? styles.active_icons_book
                        : ""
                      }`}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {isOpen.status === true && (
                    <div className="filterBoxs_testlist">
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          <>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Upcoming"}
                                value={"2"}
                                checked={status.some((element) => {
                                  if (element.id == "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id="Upcoming"
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "Upcoming",
                                    "Upcoming"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-pink"
                                htmlFor={"Upcoming"}
                              >
                                Upcoming
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name="Ongoing"
                                value={"1"}
                                checked={status.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id="Ongoing"
                                onChange={(e) =>
                                  handleCheckboxChange(e, "Ongoing", "Ongoing")
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-green"
                                htmlFor={"Ongoing"}
                              >
                                Ongoing
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name="Completed"
                                value={"0"}
                                checked={status.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id="Completed"
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "Completed",
                                    "Completed"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText GreyText"
                                htmlFor={"Completed"}
                              >
                                Completed
                              </label>
                            </li>
                          </>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClear("status")}
                              className="secondaryButton ms-2"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td
                    colSpan="15"
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    No records to display
                  </td>
                </tr>
              ) : (
                currentData?.map((course, index) => (

                  <tr key={index} title={course.id}>
                    <td id="td">{course.serialNumber}</td>
                    <td id="td">{course.name}</td>
                    <td id="td">{course.category}</td>
                    <td id="td"> {course.category_class}</td>
                    <td id="td"> {course.class_mode}</td>
                    <td id="td">
                      {" "}
                      {course.paper_type == 0
                        ? "Interview"
                        : "Class Cum Interview"}
                    </td>
                    <td id="td">{course.location_name}</td>
                    <td id="td">{course.interview_count || "-"}</td>
                    <td id="td">{course.exam_fees || "-"}</td>
                    <td id="td">
                      {" "}
                      {course.apply_last_date
                        ? moment(course.apply_last_date).format("YYYY-MM-DD")
                        : "-"}
                    </td>

                    <td id="td">
                      {moment(course.started_dt).format("DD/MM/YYYY")}
                    </td>
                    <td id="td">
                      <div>
                        {" "}
                        {moment(
                          course.created_on,
                          "DD/MM/YYYY h:mm:ss A"
                        ).format("DD/MM/YYYY")}{" "}
                      </div>
                      <div>
                        {" "}
                        {moment(
                          course.created_on,
                          "DD/MM/YYYY h:mm:ss A"
                        ).format("h:mm:ss A")}
                      </div>
                    </td>

                    <ModelExamStatus
                      course={course}
                      tenAM={tenAM}
                      currentDate={currentDate}
                    />
                    {/* {moment(course.apply_last_date).isBefore(currentDate) &&
                      currentDate.isAfter(tenAM) ? (
                      <td id="td">
                        <span className="GreenTexts">Ongoing</span>
                      </td>
                    ) : (moment(course.apply_last_date).isSame(
                      currentDate,
                      "day"
                    ) &&
                      currentDate.isBefore(tenAM)) ||
                      moment(course.apply_last_date).isAfter(
                        currentDate,
                        "day"
                      ) ? (
                      <td id="td">
                        <span className="PinkText">Upcoming</span>
                      </td>
                    ) : (
                      <td id="td">
                        <span className="GreyText">Completed</span>
                      </td>
                    )} */}

                    {/* <StatusCheck status={course}/> */}
                    <td id="td">
                      <button
                        className="button"
                        onClick={() => handleReadView(course.id, 5)}
                      >
                        <span class="material-icons">visibility</span>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={
            updateListData && updateListData?.length > 0
              ? currentPage * rowsPerPage + 1 - rowsPerPage
              : 0
          }
          endPage={
            updateListData && updateListData?.length > 0
              ? updateListData?.length < currentPage * rowsPerPage
                ? updateListData?.length
                : currentPage * rowsPerPage
              : 0
          }
          totalRecords={
            updateListData && updateListData?.length > 0
              ? updateListData?.length
              : 0
          }
          handlePrev={(e) => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${styles.prev_buttonViewAllbook} ${styles.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}

export default MockInterview;
